export const GET_MQA_TOGGLES = 'get_mqa_toggles';
export const RESET_MQA_TOGGLES = 'reset_mqa_toggles';
export const CREATE_MQA_TOGGLE = 'create_mqa_toggle';
